/* eslint-disable no-console */

/* eslint-disable no-param-reassign */

/* eslint-disable @typescript-eslint/explicit-function-return-type */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/* eslint-disable @typescript-eslint/no-explicit-any */

import { takeLatest, call, put, all, select } from 'redux-saga/effects';

import { ActionType } from 'typesafe-actions';

import * as actions from './actions';

import * as actionsParameter from './../parameter/actions';

import * as actionsCheckout from './../checkout/actions';

import { AuthActionTypes, UserAddresses } from './types';

import api from '../../../services/api';
import { ProductData } from '../product/types';
import { StoreState } from '../../createStore';
import { config } from '../../../config';
import httpsAdapter from '../../../adapters/https/https-adapter';

const erroMessage = 'Ops! ocorreu um erro no servidor';

export function* signIn({
  payload,
}: ActionType<typeof actions.signInRequest>): any {
  try {
    const { email, password } = payload;


    const response = yield call(
            [httpsAdapter, httpsAdapter.request],
            {
              data: {
                email,
                password,
              },
              isEncrypt: config.isEncryptData,
              method: 'POST',
              path: `api/customer/login?token=true`,
            }
         );

    let agreement = true;

    const { address, methods, ...customer} =  response.data.data.customer;
    yield put(
      actions.signInSuccess({
        user: {
          data: {
            ...customer,
            date_of_birth: customer.date_of_birth
              ? customer.date_of_birth
                  .split('-')
                  .reverse()
                  .join('')
              : '',
          },

          addresses: address,

          methods: methods,
        },

        agreement,
      }),
    );
    
    yield put(actionsParameter.findMethods());

    yield put(actionsParameter.addresssAll());

    yield put(actionsCheckout.getCheckout());

    yield put(actionsParameter.openShowModal(false));
  } catch (err) {
    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({
        type: 'error', message: erroMessage
      }));
    }

    yield put(actions.signInFailure(false, err.response.data.errors));
  }
}

export function* signInSocial({
  payload,
}: ActionType<typeof actions.signInSocialRequest>) {
  try {
    const { email, provider, provider_id, customer_name } = payload;

    const { data } = yield call(api.post, 'customer/login-social', {
      email,

      provider,

      provider_id,

      customer_name,
    });

    //konsole.log('actions.signInSocialRequest: ', data, status);

    let agreement = true;

    if (data.code === 'N000004') {
      // Termo de Uso não foi aceito

      agreement = false;
    } else if (data.code === 'N000005') {
      // Nova versão do Termo de Uso disponível

      agreement = false;
    }

    yield put(
      actions.signInSocialSuccess({
        user: {
          data: {
            ...data.data.customer,

            date_of_birth: data.data.customer.date_of_birth
              .split('-')
              .reverse()
              .join(''),
          },

          addresses: data.data.customer.address,

          methods: data.data.customer.methods,
        },

        agreement,
      }),
    );

    yield put(actionsCheckout.getCheckout());
  } catch (err) {
    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({
        type: 'error', message: erroMessage
      }));
    }

    yield put(actions.signInFailure());
  }
}

export function* userPaymentSelected({
  payload,
}: ActionType<typeof actions.userPaymentSelectedRequest>) {
  try {
    //konsole.log('userPaymentSelected payload:', payload);
    const { data: methods } = yield call(
      api.get,

      `methods`,
    );

    yield put(actions.userSavePaymentESitefSuccess(methods.data.methods));
  } catch (err) {
    //konsole.log(err);

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* userPaymentRemove({
  payload,
}: ActionType<typeof actions.userPaymentRemovedRequest>) {
  try {
    //konsole.log('userPaymentRemove payload:', payload);
    yield call(
      api.delete,

      `methods/${payload.method_id}`,
    );

    //konsole.log('userPaymentRemove payload:', data);

    const { data: methods } = yield call(
      api.get,

      `methods`,
    );

    //konsole.log('userPaymentRemove status', status)

    yield put(actions.userSavePaymentESitefSuccess(methods.data.methods));
  } catch (err) {
    //konsole.log(err.response);

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    if (err.response.status === 422) {
      if (err.response.data.code === 'E000003') {
        // Sem registros

        yield put(actions.userSavePaymentESitefError([]));
      }
    }

    yield put(actions.clearLoading());
  }
}

export function* userAddress({
  payload,
}: ActionType<typeof actions.userAddressRequest>) {
  try {
    //konsole.log('userAddress payload:', payload);

    if (payload) {
      payload.address.address_type = 'customer';

      payload.address.address_id = payload.address.id.toString();

      payload.address.shipping_method = 'shipment';
    }

    if (payload.address) {
      yield call(
        api.post,

        `cart/save-address`,

        payload.address,
      );

      const { data } = yield call(
        api.post,

        `addresses/selected`,

        {
          address_id: payload.address.address_id,
        },
      );

      if (data.status === 200) {
        //konsole.log('userAddress: selected', data);

        if (payload.address.address_id)
          yield put(actions.userAddressSuccess(payload.address.address_id));
      }
    }
  } catch (err) {
    if (err.response.status === 401) yield put(actions.signInFailure());
    else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());

    //konsole.log(err);
  }
}

export function* userAddressSelected({
  payload,
}: ActionType<typeof actions.userAddressSelectedRequest>) {
  try {
    //konsole.log('userAddressSelected: ', payload);
    yield call(
      api.post,

      `addresses/selected`,

      {
        address_id: payload.address.id,
      },
    );

    //konsole.log('userAddressSelected: res', data);

    yield put(actions.userAddressSuccess(payload.address.id.toString()));

    if (payload.address) {

      payload.address.address_type = 'customer';

      payload.address.address_id = payload.address.id.toString();

      payload.address.shipping_method = 'shipment';

      yield call(
        api.post,

        `cart/save-address`,

        payload.address,
      );
    }
  } catch (err) {
    //konsole.log(err);

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* userAddressRemoved({
  payload,
}: ActionType<typeof actions.userAddressRemovedRequest>) {
  try {
    //konsole.log('userAddressRemoved: ', payload);
    yield call(
      api.delete,

      `addresses/${payload.address_id}`,
    );

    const { data } = yield call(api.get, `addresses`);

    yield put(actions.userAddressRemovedSuccesss());

    yield put(actions.userAddressGetSuccess(data.data));

    yield put(actionsParameter.addresssAll());
  } catch (error) {
    if (error.response.status === 422)
      yield put(actions.userAddressGetSuccess([]));
    else if (error.response.status >= 500 && error.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* userCreatePaymentESitef({
  payload,
}: ActionType<typeof actions.userSavePaymentESitef>) {
  try {
    //konsole.log('userCreatePaymentESitef: ', payload);
    yield call(
      api.post,
      `methods/create`,
      {
        method: 'esitef',

        card_number: payload.card.card_number,

        full_name: payload.card.full_name,

        expiry_date: payload.card.expiry_date,

        media_id: 3,
      },
    );

    /*const { data: methods } = yield call(



      api.get,



      `methods`,



    );







    yield put(actions.userSavePaymentESitefSuccess(methods.data.methods));*/
  } catch (err) {
    if (err.response.status === 422) {
      yield put(actionsParameter.setMessageToast({ type: 'error', message: (err as any).response.data.data }));
    }
    else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());

    //konsole.log(err);
  }
}

export function* userListPayments({
  payload,
}: ActionType<typeof actions.userListPaymentRequest>) {
  try {
    //konsole.log('userListPayments: ', payload);
    const { data } = yield call(
      api.get,

      `methods`
    );

    yield put(actions.userListPaymentSuccess(data.data.methods));
  } catch (err) {
    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    //konsole.log(err);

    yield put(actions.clearLoading());
  }
}

export function* customerCreate({
  payload,
}: ActionType<typeof actions.customerCreateRequest>) {
  try {
    //konsole.log('customerCreate: ', payload);
    const body = {
      ...payload.customer,

      date_of_birth: `${payload.customer.date_of_birth?.slice(
        4,
        9,
      )}-${payload.customer.date_of_birth?.slice(
        2,
        4,
      )}-${payload.customer.date_of_birth?.slice(0, 2)}`,
    };

    if (payload.customer.gender && payload.customer.gender.length > 0) {
      const genderType: Record<string, string> = {
        "m": "Male",
        "n": "",
        "o": "Other",
        "f": "Female"
      }
      body.gender = genderType[payload.customer.gender];
    }
    const {
      data: { status, data, customer },
    } = yield call(
      [httpsAdapter, httpsAdapter.request],
      {
        data: body,
        isEncrypt: config.isEncryptData,
        method: 'POST',
        path: `api/customer/register`,
      }
    );
    //konsole.log('customerCreate: res ', status, message, data, customer);

    if (status === 202) {
      if (payload.messageError !== undefined) {
        yield put(
          actionsParameter.setMessageToast({
            type: 'error', message: payload.messageError
          }),
        );
      }
      yield put(actions.clearLoading());

      return;
    }

    if (status === 200 || customer.status === 0) {
      if (payload.messageSuccess !== undefined) {
        yield put(
          actionsParameter.setMessageToast({
            type: 'success', message: payload.messageSuccess
          }),
        );
      }

      if (payload.type === 'customerCreateCard') {
        yield put(
          actionsCheckout.verifyCustomerCardIsExistSucess({
            message:
              payload.messageSuccess !== undefined
                ? payload.messageSuccess
                : 'Cliente cadastrado com sucesso',

            data: data,
          }),
        );

        yield put(actions.clearLoading());
      } else {
        if (payload.step) {
          yield put(
            actions.customerCreateSuccess(
              { data: data.customer },
              payload.step,
            ),
          );
        }

        yield put(actions.customerAgreementRequest("1", "1.0"));
      }
    }
  } catch (err) {
    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    //konsole.log('customerCreate: Error|', err);

    yield put(actions.clearLoading());
  }
}

export function* customerUpdate({
  payload,
}: ActionType<typeof actions.customerUpdateRequest>) {
  try {
    //konsole.log('customerUpdate : ', payload);

    yield put(actionsParameter.setMessageToastClear());

    const {
      data: { status, code, message, data },
    } = yield call(
      api.put,

      `customer/profile`,

      payload.customer,
    );

    //konsole.log('customerUpdate: res ', status, code, message, data);

    if (status === 200 && payload.step) {
      yield put(actions.customerCreateSuccess(data, payload.step));

      if (payload.step === 'CST_STEP_04') {
        //konsole.log('customerUpdate CST_STEP_04:', payload);

        const { data } = yield call(
            [httpsAdapter, httpsAdapter.request],
            {
              data: {
                email: payload.customer.email,
                password: payload.customer.new_password,
              },
              isEncrypt: config.isEncryptData,
              method: 'POST',
              path: `api/customer/login?token=true`,
            }
         );

        const { address, methods, ...customer } =  data.data.customer;
        yield put(
          actions.signInSuccess({
            user: {
              data: customer,

              addresses: address,

              methods: methods,
            },
          }),
        );

        const { auth }: StoreState = yield select();
        yield put(
          actions.customerAgreementAccepted(auth.agreements?.id),
        );
      }
    } else if (status === 200) {
      if (code === 'S000003') {
        yield put(actionsParameter.setMessageToast({type:'success', message}));

        const { address, methods, ...customer} = data.data;

        yield put(actions.customerUpdateSuccess({
          ...customer,
          date_of_birth: customer.date_of_birth
              ? customer.date_of_birth
                  .split('-')
                  .reverse()
                  .join('')
              : '',
        }));
      }
    }
  } catch (err) {
    //konsole.log('customerUpdate->err->response', err.response);

    yield put(actions.customerUpdateFailure());

    if (err.response.status === 401) {
      yield put(actions.signOut());
    }

    if (err.response.status === 422) {
      //konsole.log("customerUpdate(422)->err->response ", err.response)

      if (err.response.data.code === 'D000001') {
        yield put(
          actionsParameter.setMessageToast({
            type: 'error',
            message: err.response.data.errors.new_password[0],
      }),
        );
      }
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* customerSendMailVerification({
  payload,
}: ActionType<typeof actions.customerSendMailRequest>) {
  try {
    //konsole.log('customerUpdate : ', payload);

    const requestMail = {
      email_phone: payload.email,

      name: payload.name,
    };

    yield call(api.post, 'verification/mail', requestMail);

    //konsole.log('customerSendMailVerification: res:', status, message, data);
  } catch (err) {
    //konsole.log('customerCreate: Error|', err);

    yield put(actions.clearLoading());
  }
}

export function* customerConfirmMailVerification({
  payload,
}: ActionType<typeof actions.customerConfirmMailRequest>) {
  try {
    //konsole.log('customerConfirmMailVerification : ', payload);

    yield put(actionsParameter.setMessageToastClear());

    const requestMail = {
      email_phone: payload.email,

      conf_code: payload.conf_code,
    };

    //konsole.log('customerConfirmMailVerification: requestMail:', requestMail);

    yield call(api.post, 'verification/mail-confirmation', requestMail);

    //konsole.log('customerConfirmMailVerification: res:', status, message, data);

    yield put(actions.customerConfirmMailSuccess());
  } catch (err) {
    //konsole.log('customerConfirmMailVerification: Error|', err.response.data);

    if (err.response.status === 422) {
      //konsole.log("customerUpdate(422)->err->response ", err.response)

      if (err.response.data.code === 'E000001') {
        yield put(
          actionsParameter.setMessageToast({
            type: 'error', message: err.response.data.data
          }),
        );
      }
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* findCEPRequest({
  payload,
}: ActionType<typeof actions.customerCEPRequest>) {
  try {
    //konsole.log('findCEPRequest : ', payload);

    const requestCEP = {
      cep: payload.postcode,
    };

    //konsole.log('findCEPRequest: requestMail:', requestCEP);

    const {
      data: { data },
    } = yield call(api.post, 'addresses/search/cep', requestCEP);

    //konsole.log('findCEPRequest: res:', status, message, data);

    yield put(actions.customerCEPSuccess(data));

    yield put(actionsParameter.addressesEditRequest(data));
  } catch (err) {
    //konsole.log('findCEPRequest: Error|', err);

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* saveAddressRequest({
  payload,
}: ActionType<typeof actions.customerSaveAddrewssRequest>) {
  try {
    //konsole.log('saveAddressRequest : ', payload);
    const addressRequest: UserAddresses = {
      address_id: payload.address.id.toString(),

      country: 'BR',

      country_name: 'Brasil',

      ...payload.address,
    };

    //konsole.log('saveAddressRequest->addressRequest: ', addressRequest);

    if (payload.address.id > 0) {
      const {
        data: { data },
      } = yield call(
        api.put,

        `addresses/${addressRequest.id}`,

        addressRequest,
      );

      yield put(actions.customerSaveAddrewssSuccess(data));
    } else {
      const {
        data: { data },
      } = yield call(
        api.post,

        `addresses/create`,

        addressRequest,
      );

      yield put(actions.customerSaveAddrewssSuccess(data));
    }

    yield put(actionsParameter.addresssAll());
  } catch (err) {
    //konsole.log('saveAddressRequest: Error|', err);

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* customerForgotPasswordClear() {
  yield put(actions.customerForgotPasswordClear());
}

export function* customerForgotPassword({
  payload,
}: ActionType<typeof actions.customerForgotPassword>) {
  try {
    const { email } = payload;

    const {
      data: { message },
    } = yield call(api.post, `/customer/forgot-password`, { email });

    yield put(actionsParameter.setMessageToast({type:'success', message: message}));
    yield put (actionsParameter.openShowModal(false));
    yield put(actions.customerForgotPasswordClear());
  } catch (err) {
    //konsole.log('ForgotPassword error');

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* customerFavoriteSave({
  payload,
}: ActionType<typeof actions.customerFavoriteSave>) {
  try {
    const { data } = yield call(api.post, `/customer/favorite/save`, {
      customer_id: payload.customer_id,

      product_id: payload.product_id,
    });

    //konsole.log('customerFavoriteSave: data', data);

    if (data.code === 'S000004') {
      //konsole.log('customerFavoriteSave: S000004', data);

      yield put(actions.customerFavoriteRemove(data.data));
    } else {
      yield put(actions.customerFavoriteSaveSuccess(data.data));
    }

    // yield put(actionsProducts.findProductRecharge());
  } catch (err) {
    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    //konsole.log('customerFavoriteSave error');

    yield put(actions.clearLoading());
  }
}

export function* customerFavoriteList() {
  try {
    const { parameter }: StoreState = yield select();
    const storeFilter = !parameter.multistoreSelected.store_id ? '' : `?store_id=${parameter.multistoreSelected.store_id}`;
    const { data } = yield call(
      api.get,
      `/customer/favorite${storeFilter}`,
    );

    yield put(actions.customerFavoriteListSuccess(data.data.filter((data: ProductData) => data && data.id)));
  } catch (err) {
    //konsole.log('customerFavoriteList error');

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* customerAgreementAccepted({
  payload,
}: ActionType<typeof actions.customerAgreementAccepted>) {
  try {
    const { data } = yield call(
      api.post,
      `/customer/agreement`,
      {
        agreement_id: payload.agreement_id,
      },
    );

    yield put(actions.customerAgreementAcceptedSuccess(data.data));
  } catch (err) {
    //konsole.log('customerFavoriteList error');

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* customerAgreementRequest({
  payload,
}: ActionType<typeof actions.customerAgreementRequest>) {

  try {
    const { data } = yield call(
      api.post,
      `/customer/agreement?agreement_id=${payload.type}`,
      {
        type: payload.type,

        version: payload.version,
      },
    );

    yield put(actions.customerAgreementRequestSuccess(data.data));
  } catch (err) {
    //konsole.log('customerFavoriteList error');

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* onsignOut() {
  try {
    yield put(actionsParameter.findMethodsSuccess([]));

    yield put(actionsParameter.addresssAllFailure());

    yield put(actionsParameter.findMethodsAllSuccess([]));

    yield put(actionsParameter.addresssPostcodeSuccess({} as UserAddresses));

    yield put(actions.signOutSucess());

    yield put(actionsCheckout.checkoutFailure());
  } catch (err) {
    //konsole.log('customerFavoriteList error');
  }

  try {
    yield call(
      api.get,
      'customer/logout'
    );
  } catch (err) {
    //konsole.log('customerFavoriteList error');
  }
}

export function* verifyCustomerIsExistRequest({
  payload,
}: ActionType<typeof actions.verifyCustomerIsExist>) {
  try {
    //konsole.log('orderByIdRemakeRequest:', type, payload);

    const { data } = yield call(api.post, `customer/verify`, {
      data: payload.userCreate.email,
    });

    if (data.status === 202) {
      yield put(actions.customerIsExist(payload.messageCustomerIsExist));

      return;
    }

    yield put(
      actions.verifyCustomerIsExistSucess(payload.userCreate, payload.step),
    );
  } catch (err) {
    //konsole.log('orderByIdRemakeRequest: err', err);

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

//VERIFICAR SE EMAIL JA É CADASTRADO

export function* verifyEmailExistRequest({
  payload,
}: ActionType<typeof actions.verifyEmailExist>) {
  try {
    const { data } = yield call(api.post, `customer/verify`, {
      data: payload.email,
    });

    if (data.status === 202) {
      yield put(actions.verifyEmailExistSuccess());

      if (payload.messageSuccess !== undefined) {
        yield put(
          actionsParameter.setMessageToast({
            type: 'success', message: payload.messageSuccess
          }),
        );
      }

      return;
    }

    if (data.status === 200) {
      yield put(actions.verifyEmailExistError());
      return;
    }
  } catch (err) {
    //konsole.log('orderByIdRemakeRequest: err', err);

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

export function* removeAccountCustomerRequest({
  payload,
}: ActionType<typeof actions.removeAccountCustomer>) {
  try {
    //konsole.log('orderByIdRemakeRequest:', type, payload);
    const { data } = yield call(
      api.get,

      `customer/cancel`,
    );

    if (data.status === 200) {
      yield put(
        actionsParameter.setMessageToast({
          type: 'success', message: payload.messageSuccess
        })
      );

      yield put(actions.signOut());
    }
  } catch (err) {
    //konsole.log('orderByIdRemakeRequest: err', err);

    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({type:'error', message: erroMessage}));
    }

    yield put(actions.clearLoading());
  }
}

//RESET SENHA

export function* customerResetPassword({
  payload,
}: ActionType<typeof actions.customerResetPassword>) {
  try {
    const token = payload.token;

    const email = payload.email;

    const password = payload.password;

    const password_confirmation = payload.password_confirmation;

    const {
      data: { message },
    } = yield call(api.post, `/customer/update-password`, {
      token,
      email,
      password,
      password_confirmation,
    });

    yield put(actions.customerResetPasswordSuccess(message));

    // yield put(actions.customerForgotPasswordClear());

    yield put(actionsParameter.setMessageToast({type:'success', message}));
  } catch (err) {
    //konsole.log('ForgotPassword error');

    // eslint-disable-next-line

    if ((err.response.status = 422)) {
      const message = err.response.data.data === 'Este token de redefinição de senha é inválido.' ? 
      "Ops! Este link de redefinição de senha não é mais válido." 
      : "Ocorreu um erro. Por favor tentar novamente."
      yield put(
        actionsParameter.setMessageToast({
          type: 'error',
          message,
      }),
      );
    }

    yield put(actions.clearLoading());
  }
}

export default all([
  takeLatest(AuthActionTypes.SIGN_IN_REQUEST, signIn),

  takeLatest(AuthActionTypes.SIGN_IN_SOCIAL_REQUEST, signInSocial),

  takeLatest(AuthActionTypes.PAYMENT_SEL_REQUEST, userPaymentSelected),

  takeLatest(AuthActionTypes.PAYMENT_REMOVE_REQUEST, userPaymentRemove),

  takeLatest(AuthActionTypes.ADDRESS_REQUEST, userAddress),

  takeLatest(AuthActionTypes.CARD_ESITEF_REQUEST, userCreatePaymentESitef),

  takeLatest(AuthActionTypes.CARD_LIST_REQUEST, userListPayments),

  takeLatest(AuthActionTypes.CUSTOMER_CREATE_REQUEST, customerCreate),

  takeLatest(AuthActionTypes.CUSTOMER_UPDATE_REQUEST, customerUpdate),

  takeLatest(AuthActionTypes.CUSTOMER_SEND_MAIL, customerSendMailVerification),

  takeLatest(
    AuthActionTypes.CUSTOMER_CONFIRM_MAIL,

    customerConfirmMailVerification,
  ),

  takeLatest(AuthActionTypes.CUSTOMER_CEP_REQUEST, findCEPRequest),

  takeLatest(
    AuthActionTypes.CUSTOMER_CREATE_ADDRESS_REQUEST,

    saveAddressRequest,
  ),

  takeLatest(AuthActionTypes.ADDRESS_SELECTED_REQUEST, userAddressSelected),

  takeLatest(AuthActionTypes.ADDRESS_REMOVED_REQUEST, userAddressRemoved),

  takeLatest(AuthActionTypes.CUSTOMER_FORGOT_PASS, customerForgotPassword),

  takeLatest(AuthActionTypes.CUSTOMER_RESET_PASS, customerResetPassword),

  takeLatest(AuthActionTypes.CUSTOMER_FAVORITE_SAVE, customerFavoriteSave),

  takeLatest(AuthActionTypes.CUSTOMER_FAVORITE_LIST, customerFavoriteList),

  takeLatest(
    AuthActionTypes.CUSTOMER_AGREEMENT_REQUEST,
    customerAgreementRequest,
  ),

  takeLatest(
    AuthActionTypes.CUSTOMER_AGREEMENT_ACCEPTED,
    customerAgreementAccepted,
  ),

  takeLatest(AuthActionTypes.SIGNOUT_REQUEST, onsignOut),

  takeLatest(
    AuthActionTypes.VERIFY_CUSTOMER_IS_EXIST,
    verifyCustomerIsExistRequest,
  ),

  takeLatest(
    AuthActionTypes.REMOVE_ACCOUNT_CUSTOMER,
    removeAccountCustomerRequest,
  ),

  takeLatest(AuthActionTypes.VERIFY_EMAIL_EXIST, verifyEmailExistRequest),
]);
